import { Pill } from '@mantine/core';
import * as React from 'react';

import { FieldSelectMultiStore } from 'stores/local/shared/form/FieldSelectStore';
import { OptionEntity } from 'types/OptionEntity';

type ValueItemProps = {
  store: FieldSelectMultiStore;
  item: OptionEntity;
};

const ValueItem: React.FC<ValueItemProps> = ({ store, item }) => {
  const onRemove = React.useCallback(() => {
    store.removeByKey(item.key);
  }, [store, item.key]);

  return (
    <Pill withRemoveButton onRemove={onRemove}>
      {item.value}
    </Pill>
  );
};

export default React.memo(ValueItem);
